/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GoogleAuthControllerGoogleCallbackV1$Params {
}

export function googleAuthControllerGoogleCallbackV1(http: HttpClient, rootUrl: string, params?: GoogleAuthControllerGoogleCallbackV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'accessToken'?: string;
'refreshToken'?: string;
'user'?: {
};
}>> {
  const rb = new RequestBuilder(rootUrl, googleAuthControllerGoogleCallbackV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'accessToken'?: string;
      'refreshToken'?: string;
      'user'?: {
      };
      }>;
    })
  );
}

googleAuthControllerGoogleCallbackV1.PATH = '/api/v1/oauth/google/callback';
